export const GtmEvents = {
  DESIGN_PROFILE_QUIZ_STEP: "design_profile_step",
  DESIGN_PROFILE_QUIZ_STARTED: "design_profile_start",
  DESIGN_PROFILE_COMPLETE: "design_profile_complete",
  VIEW_ITEM: "view_item",
  ADD_TO_CART: "add_to_cart",
  BEGIN_CHECKOUT: "begin_checkout",
  PURCHASE: "purchase",
  SHOP_PRODUCT_SHOP_CLICK: "shop_product_shop_click",
  AUTH_STATE_CHANGE: "auth_state_change",
  GENERATE_LEAD: "generate_lead",
  YARDAI_START: "yardai_start",
  YARDAI_FRONT_YARD_SELECT: "yardai_front_yard_select",
  YARDAI_BACK_YARD_SELECT: "yardai_back_yard_select",
  YARDAI_PHOTO_UPLOAD: "yardai_photo_upload",
  YARDAI_EXAMPLE_IMAGE: "yardai_example_image",
  YARDAI_STYLE_SELECT: "yardai_style_select",
  YARDAI_LEAD_CAPTURED: "yardai_lead_captured",
  YARDAI_COMPLETE: "yardai_complete",
  YARDAI_START_OVER: "yardai_start_over",
  YARDAI_UPGRADE_CLICK: "yardai_upgrade_click",
  YARDAI_DOWNLOAD: "yardai_download",
  YARDAI_GENERATION_ERROR: "yardai_generation_error",
  YARDAI_PRODUCT_SHOP_CLICK: "yardai_product_shop_click",
  YARDAI_PRODUCT_LEARN_MORE_CLICK: "yardai_product_learn_more_click",
  YARDAI_EXPLORE_PACKAGES: "yardai_explore_packages",
  YARDAI_ABOUT_CLICK: "yardai_about_click",
  YARDAI_ABOUT_TRY_NOW: "yardai_about_try_now",
  YFP_LOGIN: "yfp_login",
  YFP_SIGNUP_START: "yfp_signup_start",
  YFP_SIGNUP_COMPLETE: "yfp_signup_complete",
  YFP_START: "yfp_start",
  YFP_PHOTO_UPLOAD: "yfp_photo_upload",
  YFP_SATELLITE_IMAGE: "yfp_satellite_image",
  YFP_FRONT_YARD_SELECT: "yfp_front_yard_select",
  YFP_BACK_YARD_SELECT: "yfp_back_yard_select",
  YFP_STYLE_SELECT: "yfp_style_select",
  YFP_COMPLETE: "yfp_complete",
  YFP_GENERATION_ERROR: "yfp_generation_error",
  YFP_EDIT_FEATURES_PROMPT_CLICK: "yfp_edit_features_prompt_click",
  YFP_PICK_ANOTHER_STYLE_CLICK: "yfp_pick_another_style_click",
  YFP_PROMPT_ADJUSTMENTS_CLICK: "yfp_prompt_adjustments_click",
  YFP_DOWNLOAD_CLICK: "yfp_download_click",
  YFP_COPY_LINK_CLICK: "yfp_copy_link_click",
  YFP_DESIGN_PROJECT_CLICK: "yfp_design_project_click",
  YFP_DESIGN_PROJECT_PURCHASED: "yfp_design_project_purchased",
  YFP_START_ESTIMATE_CLICK: "yfp_start_estimate_click",
  YFP_ESTIMATE_SEND_CLIENT: "yfp_estimate_send_client",
  YFP_ESTIMATE_EXPORT_PDF: "yfp_estimate_export_pdf",
  YFP_ESTIMATE_EXPORT_JOBBER: "yfp_estimate_export_jobber",
  YFP_ESTIMATE_EXPORT_BUILDERTREND: "yfp_estimate_export_buildertrend",
  YFP_PRODUCT_SHOP_CLICK: "yfp_product_shop_click",
  YFP_PRODUCT_LEARN_MORE_CLICK: "yfp_product_learn_more_click",
};
